export default __webpack_public_path__ + "static/media/hht2_ep03_timeline_q03_a.56231310.png";